import { getQueryString } from "../shared/utils";
/**
 * GET the current policy's product ID based on values from the policy
 *
 * @param {String} apiQuotingUrl
 * @param {String} policyId
 * @returns {Promise<string>}
 */

export default function getProductId(_ref) {
  var apiQuotingUrl = _ref.apiQuotingUrl,
      policyId = _ref.policyId;
  var queryString = getQueryString({
    policyId: policyId,
    postbind: "true"
  });
  return fetch(apiQuotingUrl + "/products?" + queryString, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Cache-Control": "no-cache"
    }
  }).then(function (res) {
    if (!res.ok) {
      throw new Error("Failed to fetch the product ID.");
    }

    return res.json();
  }).then(function (json) {
    // Ensure that the response we got is what we want.
    // Example `productId`: fnic-ho3-sc-20160615:20160731-postbind
    // prettier-ignore
    var productId = Array.isArray(json) && // response exists as an array
    json.length === 1 && // with one item
    typeof json[0] === "object" && // being an object
    json[0].id // having a key of `id`
    ? json[0].id : "";

    if (!productId) {
      // If the response is not what we expected and didn't yield a `productId`,
      // throw an error
      throw new Error("Unable to retrieve product ID. Expected a single product with an ID from the API (received " + json.length + " products).");
    }

    return productId;
  });
}